import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";

function DeleteAccount() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col md={10} style={{ paddingBottom: "50px" }}>
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }} className="project-heading">
              Delete <strong className="purple">Account</strong>
            </h1>
            <div
              style={{
                textAlign: "left",
                color: "white",
                padding: "20px",
                backgroundColor: "rgba(0,0,0,0.5)",
                borderRadius: "10px",
                marginTop: "20px",
                lineHeight: "1.7",
              }}
            >
              <p>
                This page explains how users of the Sensa Smart app can request deletion
                of their account and related data.
              </p>

              <h2 style={{ color: "#c770f0" }}>How to delete your account</h2>
              <ol>
                <li>Open the Sensa Smart app and sign in to your account.</li>
                <li>Go to Settings.</li>
                <li>Open User Information / Profile.</li>
                <li>Tap the delete account action in the top-right corner.</li>
                <li>Confirm the deletion request.</li>
              </ol>

              <h2 style={{ color: "#c770f0" }}>What data is deleted</h2>
              <ul>
                <li>Account profile information such as name, email address, and phone number.</li>
                <li>App account access associated with your Sensa Smart user profile.</li>
                <li>Associated homes, devices, automation records, and account-linked settings that are owned by your account, subject to operational constraints.</li>
              </ul>

              <h2 style={{ color: "#c770f0" }}>What may be retained</h2>
              <ul>
                <li>Limited operational, security, fraud-prevention, and legal compliance records when retention is required.</li>
                <li>Short-lived backups that are automatically overwritten according to the backup retention cycle.</li>
              </ul>

              <h2 style={{ color: "#c770f0" }}>Retention timing</h2>
              <p>
                We process account deletion requests as soon as reasonably possible. Some
                operational records and backups may remain for a limited retention period
                before permanent removal.
              </p>

              <h2 style={{ color: "#c770f0" }}>Need help</h2>
              <p>
                If you cannot access the app or need support with account deletion, contact:
                {" "}
                <strong>vulewenlian94@gmail.com</strong>
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}

export default DeleteAccount;
